export const ADMIN_AUTH_LOGIN = 'ADMIN_AUTH_LOGIN'
export const ADMIN_AUTH_LOGOUT = 'ADMIN_AUTH_LOGOUT'
export const ADMIN_USERINFO_SETUSERINFO = 'ADMIN_USERINFO_SETUSERINFO'

// 管理者用グローバルメニューの状態変更
export const ADMIN_USERCHOICE_STATUSGLOBALMENU   = 'ADMIN_USERCHOICE_STATUSGLOBALMENU'

// 時間帯マスタ操作時 一覧から詳細
export const ADMIN_USERCHOICE_WTMZN_LISTTODETAIL = 'ADMIN_USERCHOICE_WTMZN_LISTTODETAIL'
// 検査項目マスタ操作時 一覧から詳細
export const ADMIN_USERCHOICE_WKKMM_LISTTODETAIL = 'ADMIN_USERCHOICE_WKKMM_LISTTODETAIL'
// 予約枠マスタ操作時 一覧から詳細
export const ADMIN_USERCHOICE_WWAKU_LISTTODETAIL = 'ADMIN_USERCHOICE_WWAKU_LISTTODETAIL'
// メールテンプレートマスタ操作時 一覧から詳細
export const ADMIN_USERCHOICE_WMAIL_LISTTODETAIL = 'ADMIN_USERCHOICE_WMAIL_LISTTODETAIL'
// オプション分類マスタ操作時 一覧から詳細
export const ADMIN_USERCHOICE_WOPBR_LISTTODETAIL = 'ADMIN_USERCHOICE_WOPBR_LISTTODETAIL'
// オプション項目マスタ操作時 一覧から詳細
export const ADMIN_USERCHOICE_WOPKM_LISTTODETAIL = 'ADMIN_USERCHOICE_WOPKM_LISTTODETAIL'
// クライアントマスタ操作時 一覧から詳細
export const ADMIN_USERCHOICE_WJGYO_LISTTODETAIL = 'ADMIN_USERCHOICE_WJGYO_LISTTODETAIL'
// 対象者区分マスタ操作時 一覧から詳細
export const ADMIN_USERCHOICE_WHFKB_LISTTODETAIL = 'ADMIN_USERCHOICE_WHFKB_LISTTODETAIL'

// コースマスタ操作時 クライアントコードで検索したとき
export const ADMIN_USERCHOICE_WIRKS_SEARCH = 'ADMIN_USERCHOICE_WIRKS_SEARCH'

// コースマスタ操作時 一覧から新規登録
export const ADMIN_USERCHOICE_WIRKS_LISTTOREGISTER = 'ADMIN_USERCHOICE_WIRKS_LISTTOREGISTER'
// コースマスタ操作時 一覧からメニューに戻る
export const ADMIN_USERCHOICE_WIRKS_LISTTOHOME = 'ADMIN_USERCHOICE_WIRKS_LISTTOHOME'
// コースマスタ操作時 一覧から年度更新
export const ADMIN_USERCHOICE_WIRKS_BULK = 'ADMIN_USERCHOICE_WIRKS_BULK'
// コースマスタ操作時 一覧から詳細
export const ADMIN_USERCHOICE_WIRKS_LISTTODETAIL = 'ADMIN_USERCHOICE_WIRKS_LISTTODETAIL'
// コースマスタ操作時 一覧から詳細 コース毎検査項目マスタ 詳細画面
export const ADMIN_USERCHOICE_WIRKS_LISTTOIRKM = 'ADMIN_USERCHOICE_WIRKS_LISTTOIRKM'
// コースマスタ操作時 一覧から詳細 コース毎予約枠マスタ 詳細画面
export const ADMIN_USERCHOICE_WIRKS_LISTTOKSWK = 'ADMIN_USERCHOICE_WIRKS_LISTTOKSWK'
// コースマスタ操作時 一覧から詳細 コース毎料金条件マスタ 詳細画面
export const ADMIN_USERCHOICE_WIRKS_LISTTORKKS = 'ADMIN_USERCHOICE_WIRKS_LISTTORKKS'
// コースマスタ操作時 一覧から詳細 コース毎オプションマスタ 詳細画面
export const ADMIN_USERCHOICE_WIRKS_LISTTOOPTION = 'ADMIN_USERCHOICE_WIRKS_LISTTOOPTION'
// コースマスタ操作時 各関連画面（※）からコースマスタ画面に戻る
// （※ 詳細、年度更新、コース毎検査項目マスタ、コース毎予約枠マスタ、
//       コース毎料金条件マスタ、コース毎オプション条件マスタ）
export const ADMIN_USERCHOICE_WIRKS_BACKTOLIST = 'ADMIN_USERCHOICE_WIRKS_BACKTOLIST'

// 受診者抽出 詳細ボタン押下時
export const ADMIN_USERCHOICE_WIGA1_DETAIL = 'ADMIN_USERCHOICE_WIGA1_DETAIL'
// 予約状況編集 初期表示
export const ADMIN_USERCHOICE_WIGA1DETAIL_FIRSTDISPLAY = 'ADMIN_USERCHOICE_WIGA1DETAIL_FIRSTDISPLAY'
// 予約状況編集 受診者抽出画面に戻る、更新ボタン押下時
export const ADMIN_USERCHOICE_WIGA1DETAIL_RESET = 'ADMIN_USERCHOICE_WIGA1DETAIL_RESET'
// 予約状況詳細カレンダー選択画面で変更日、変更時間帯を選んだ時
export const ADMIN_USERCHOICE_WIGA1_CHOICEDATETMZN = 'ADMIN_USERCHOICE_WIGA1_CHOICEDATETMZN'

// CSVパターン操作時 一覧から詳細
export const ADMIN_USERCHOICE_CSVPATTERN_LISTTODETAIL = 'ADMIN_USERCHOICE_CSVPATTERN_LISTTODETAIL'
// CSVパターン操作時 詳細から一覧へ戻る
export const ADMIN_USERCHOICE_CSVPATTERN_BACKTOLIST = 'ADMIN_USERCHOICE_CSVPATTERN_BACKTOLIST'

// 医療機関の情報更新時に医療機関名を更新
export const ADMIN_USERCHOICE_WIRKN = 'ADMIN_USERCHOICE_WIRKN'

// 受診者抽出画面検索欄
export const ADMIN_WIGA1_SEARCH = 'ADMIN_WIGA1_SEARCH'
// 受診者抽出画面検索欄絞り込み項目 
// ステータス
export const ADMIN_WIGA1_SEARCH_YKST = 'ADMIN_WIGA1_SEARCH_YKST'
// ダウンロード状況
export const ADMIN_WIGA1_SEARCH_CSST = 'ADMIN_WIGA1_SEARCH_CSST'
// 氏名（カナ）
export const ADMIN_WIGA1_SEARCH_RYAK = 'ADMIN_WIGA1_SEARCH_RYAK'
// 氏名（漢字）
export const ADMIN_WIGA1_SEARCH_NAME = 'ADMIN_WIGA1_SEARCH_NAME'
// 受診時間
export const ADMIN_WIGA1_SEARCH_TMZN = 'ADMIN_WIGA1_SEARCH_TMZN'

// 以下より一般ユーザー系
// 一般ユーザーログイン成功時
export const COMMON_AUTH_LOGIN = 'COMMON_AUTH_LOGIN'
// 一般ユーザーログアウト
export const COMMON_AUTH_LOGOUT = 'COMMON_AUTH_LOGOUT'
// 一般ユーザーナビゲーション表示の切り替え
export const COMMON_DISPLAYNAVIGATION = 'COMMON_DISPLAYNAVIGATION'
// 一般ユーザーTOP画面 初期表示時、医療機関情報の登録
export const COMMON_SETIRKNINFO = 'COMMON_SETIRKNINFO'
// 一般ユーザーログイン後、一般ユーザー情報の登録
export const COMMON_USERINFO_SETUSERINFO = 'COMMON_USERINFO_SETUSERINFO'
// 一般ユーザー マイページ 初期表示時
export const COMMON_MYPAGE_FIRSTDISPLAY = 'COMMON_MYPAGE_FIRSTDISPLAY'
// 一般ユーザー マイページ 個人として新規予約
export const COMMON_MYPAGE_RESERVEKOJIN = 'COMMON_MYPAGE_RESERVEKOJIN'
// 一般ユーザー マイページ 健保使って新規予約
export const COMMON_MYPAGE_RESERVEHELTH = 'COMMON_MYPAGE_RESERVEHELTH'
// 一般ユーザー マイページ 予約詳細ボタン押下時
export const COMMON_MYPAGE_RESERVEDETAIL = 'COMMON_MYPAGE_RESERVEDETAIL'
// 一般ユーザー マイページ 予約変更ボタン押下時
export const COMMON_MYPAGE_RESERVECHANGE = 'COMMON_MYPAGE_RESERVECHANGE'
// 一般ユーザー マイページ 予約キャンセルボタン押下時
export const COMMON_MYPAGE_RESERVECANCEL = 'COMMON_MYPAGE_RESERVECANCEL'
// 一般ユーザー 予約詳細 戻るボタン押下時
export const COMMON_RESERVEDETAIL_BACK = 'COMMON_RESERVEDETAIL_BACK'
// 一般ユーザー 予約キャンセル確認 戻るボタン押下時
export const COMMON_CONFIRMCANCEL_BACK = 'COMMON_CONFIRMCANCEL_BACK'
// 一般ユーザー 予約キャンセル確認 キャンセルを確定する押下時
export const COMMON_CONFIRMCANCEL_DECISION = 'COMMON_CONFIRMCANCEL_DECISION'
// 一般ユーザー 新規健保予約画面 年齢の登録
export const COMMON_NEWHEALTHINSURANCE = 'COMMON_NEWHEALTHINSURANCE'
// 一般ユーザー 個人（新規健保予約画面を経由しない場合）
export const COMMON_KOJIN = 'COMMON_KOJIN'
// 一般ユーザー 新規健保予約画面 新規健保予約画面からマイページに戻る
// ユーザータイプが1: マイページ経由かつ新規予約（健保）
export const COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE1 = 'COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE1'
// 一般ユーザー 新規健保予約画面 新規健保予約画面からマイページに戻る
// ユーザータイプが3: マイページ経由かつ予約変更（健保）
export const COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE3 = 'COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE3'
 // 一般ユーザー 新規健保予約画面 新規健保予約画面からマイページに戻る
// ユーザータイプが5: ゲストログインかつ新規予約（健保）
export const COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE5 = 'COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE5'
// 一般ユーザー コース選択画面
export const COMMON_SELECTCOURSE = 'COMMON_SELECTCOURSE'
// 一般ユーザー コース選択画面 コース選択画面からマイページに戻る
// ユーザータイプが0: マイページ経由かつ新規予約（個人）
export const COMMON_SELECTCOURSE_BACK_USERTYPE0 = 'COMMON_SELECTCOURSE_BACK_TO_TOP_USERTYPE0'
// 一般ユーザー コース選択画面 コース選択画面から新規健保予約画面に戻る
// ユーザータイプが1: マイページ経由かつ新規予約（健保）
export const COMMON_SELECTCOURSE_BACK_USERTYPE1 = 'COMMON_SELECTCOURSE_BACK_TO_TOP_USERTYPE1'
// 一般ユーザー コース選択画面 コース選択画面からマイページに戻る
// ユーザータイプが2: マイページ経由かつ予約変更（個人）
export const COMMON_SELECTCOURSE_BACK_USERTYPE2 = 'COMMON_SELECTCOURSE_BACK_TO_TOP_USERTYPE2'
// 一般ユーザー コース選択画面 コース選択画面から新規健保予約画面に戻る
// ユーザータイプが3: マイページ経由かつ予約変更（健保）
export const COMMON_SELECTCOURSE_BACK_USERTYPE3 = 'COMMON_SELECTCOURSE_BACK_TO_TOP_USERTYPE3'
// 一般ユーザー コース選択画面 コース選択画面からトップページに戻る
// ユーザータイプが4: ゲストログインかつ新規予約（個人）
export const COMMON_SELECTCOURSE_BACK_USERTYPE4 = 'COMMON_SELECTCOURSE_BACK_TO_TOP_USERTYPE4'
// 一般ユーザー コース選択画面 コース選択画面から新規健保予約画面に戻る
// ユーザータイプが5: ゲストログインかつ新規予約（健保）
export const COMMON_SELECTCOURSE_BACK_USERTYPE5 = 'COMMON_SELECTCOURSE_BACK_TO_TOP_USERTYPE5'
// 一般ユーザー コース選択画面 コース選択画面からトップページに戻る
// ログアウト処理が行われる
// ユーザータイプが6: 途中ログインかつ新規予約（個人）
export const COMMON_SELECTCOURSE_BACK_USERTYPE6 = 'COMMON_SELECTCOURSE_BACK_TO_TOP_USERTYPE6'
// 一般ユーザー コース選択画面 コース選択画面からトップページに戻る
// ユーザータイプが7: 途中ログインかつ新規予約（健保）
export const COMMON_SELECTCOURSE_BACK_USERTYPE7 = 'COMMON_SELECTCOURSE_BACK_TO_TOP_USERTYPE7'
// 一般ユーザー オプション選択画面 初期表示
export const COMMON_SELECTOPTION_FIRSTDISPLAY = 'COMMON_SELECTOPTION_FIRSTDISPLAY'
// 一般ユーザー オプション選択画面
export const COMMON_SELECTOPTION = 'COMMON_SELECTOPTION'
// 一般ユーザー オプション選択画面 オプション選択画面からコース選択画面に戻る
export const COMMON_SELECTOPTION_BACK = 'COMMON_SELECTOPTION_BACK'
// 一般ユーザー カレンダー選択画面 初期表示
export const COMMON_SELECTCALENDER_FIRSTDISPLAY = 'COMMON_SELECTCALENDER_FIRSTDISPLAY'
// 一般ユーザー カレンダー選択画面
export const COMMON_SELECTCALENDER = 'COMMON_SELECTCALENDER'
// 一般ユーザー カレンダー選択画面 カレンダー選択画面からオプション選択画面に戻る
export const COMMON_SELECTCALENDER_BACK = 'COMMON_SELECTCALENDER_BACK'
// 一般ユーザー 予約情報入力画面 初期表示
export const COMMON_INPUTRESERVEINFO_FIRSTDISPLAY = 'COMMON_INPUTRESERVEINFO_FIRSTDISPLAY'
// 一般ユーザー 予約情報入力画面 ボタン押下時
export const COMMON_INPUTRESERVEINFO = 'COMMON_INPUTRESERVEINFO'
// 一般ユーザー 予約情報入力画面 予約情報入力画面からカレンダー選択画面に戻る
export const COMMON_INPUTRESERVEINFO_BACK = 'COMMON_INPUTRESERVEINFO_BACK'
// 一般ユーザー 予約情報確認画面
export const COMMON_CONFIRMRESERVE_FIRSTDISPLAY = 'COMMON_CONFIRMRESERVE_FIRSTDISPLAY'
// 一般ユーザー 予約情報確認画面 確定するボタン押下時（新規予約） 各パラメーターリセット
export const COMMON_CONFIRMRESERVE_REGISTERLOGININFO = 'COMMON_CONFIRMRESERVE_REGISTERLOGININFO'
// 一般ユーザー 予約情報確認画面 確定するボタン押下時 既ログイン時 各パラメーターリセット、ユーザー情報一部再取得
export const COMMON_CONFIRMRESERVE_LOGINED = 'COMMON_CONFIRMRESERVE_LOGINED'
// グローバルメニューからマイページへ遷移時
export const COMMON_TO_MYPAGE = 'COMMON_TO_MYPAGE'
// グローバルメニューからパスワード変更画面へ遷移時
export const COMMON_TO_CHANGEPASSWORD = 'COMMON_TO_CHANGEPASSWORD'

// 以下より 一般ユーザー 予約情報入力画面テスト用
// 0: マイページ経由かつ新規予約（個人）
export const COMMON_INPUTRESERVEINFO_TEST0 = 'COMMON_INPUTRESERVEINFO_TEST0'
// 1: マイページ経由かつ新規予約（健保）
export const COMMON_INPUTRESERVEINFO_TEST1 = 'COMMON_INPUTRESERVEINFO_TEST1'
// 2: マイページ経由かつ予約変更（個人）
export const COMMON_INPUTRESERVEINFO_TEST2 = 'COMMON_INPUTRESERVEINFO_TEST2'
// 3: マイページ経由かつ予約変更（健保）
export const COMMON_INPUTRESERVEINFO_TEST3 = 'COMMON_INPUTRESERVEINFO_TEST3'
// 4: ゲストログインかつ新規予約（個人）
export const COMMON_INPUTRESERVEINFO_TEST4 = 'COMMON_INPUTRESERVEINFO_TEST4'
// 5: ゲストログインかつ新規予約（健保）
export const COMMON_INPUTRESERVEINFO_TEST5 = 'COMMON_INPUTRESERVEINFO_TEST5'
// 6: 途中ログインかつ新規予約（個人）
export const COMMON_INPUTRESERVEINFO_TEST6 = 'COMMON_INPUTRESERVEINFO_TEST6'
// 7: 途中ログインかつ新規予約（健保）
export const COMMON_INPUTRESERVEINFO_TEST7 = 'COMMON_INPUTRESERVEINFO_TEST7'








// WEBPACK FOOTER //
// ./src/store/mutation-types.js